export const getDateFormat = ({ locale, date, options = {} }) => new Intl.DateTimeFormat(locale, options).format(date);
